module.exports = __webpack_public_path__ + "static/media/RobotoMono-Regular.a48ac416.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Fonts/RobotoMono-Regular.ttf
// module id = 113
// module chunks = 0